export const DISTRIBUTION_COLORS = [
  '#0D86FF',
  '#0B4E9D',
  '#D7E9FF',
  '#DFFBE8',
  '#2CA46F',
  '#20A86C',
  '#8AA4FF',
]

export const STATUS_SPLIT_ITEMS = [
  { name: 'Initiated', color: '#0D86FF' },
  { name: 'Processing', color: '#0B4E9D' },
  { name: 'Approved', color: '#2CA46F' },
]
